import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/*
 * tailwind-merge only knows Tailwind's default scale names. Without this, the
 * named type scale (`text-body`, `text-label`…) would be read as text colors and
 * `cn("text-foreground", "text-body")` would drop one of them. Keep in sync
 * with the @theme blocks in apps/web/src/styles/globals.css.
 */
const twMerge = extendTailwindMerge<"press" | "press-glyph">({
  extend: {
    theme: {
      text: ["2xs", "caption", "label", "body", "body-tight", "body-lg", "title", "page-title", "stat", "headline", "display", "display-lg"],
      shadow: ["popover", "modal"],
      radius: ["control", "card", "sheet", "deck"],
      // Motion (spec 07 › Movimiento). `ease-in`, `ease-out` and `ease-in-out` are Tailwind's own names.
      ease: ["enter", "exit", "move", "settle", "sheet"],
      animate: [
        "fade-in", "fade-out", "ink", "ink-hot", "enter-pop", "exit-pop", "zoom-in", "zoom-out", "popover-in", "popover-out",
        "pop-glyph", "pop-disc", "stamp", "nudge", "float-in", "float-out", "tray-in", "tray-out", "dock-in", "dock-out",
        "toast-in", "toast-in-side", "toast-out", "toast-out-side", "line-out", "indicator", "search-reveal",
        "sheet-in-right", "sheet-in-left", "sheet-in-bottom", "sheet-out-right", "sheet-out-left", "sheet-out-bottom",
        "split-pane-in", "chat-in", "check-draw", "sweep", "breathe", "shimmer", "text-shimmer", "ring-orbit",
      ],
    },
    classGroups: {
      duration: [{ duration: ["press", "instant", "fast", "base", "moderate", "slow", "fast-exit", "base-exit", "moderate-exit", "slow-exit", "push", "pop"] }],
      delay: [{ delay: ["indicator", "tooltip"] }],
      // Each press recipe writes the element's own transition list: an element
      // keeps one, and never a `transition-*` on top (it would drop the press
      // scale without a word). `press-glyph` only styles the glyph inside, so it
      // composes with `press` on the same button (IconButton over Button).
      press: ["press", "press-row", "hover-tint"],
      "press-glyph": ["press-glyph"],
    },
    conflictingClassGroups: {
      press: ["transition"],
      transition: ["press"],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
